const translations = {
    validFaaReferenceNumber: 'Please enter a valid reference number'
};

export default translations;
